import type { DropdownOption } from '@talentmesh/utils';

const workArrangementOptions: DropdownOption[] = [
    { id: 'OnLocation', name: 'On location' },
    { id: 'Hybrid', name: 'Hybrid' },
    { id: 'Remote', name: 'Remote' },
];

export default workArrangementOptions;
